import axios from 'axios'

export const registerCustomer = (data) => {
  return axios.post('/auth/register/customer', data)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const registerMerchant = (data) => {
  return axios.post('/register/merchant', data)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const login = (data) => {
  return axios.post(`/${data.passcode ? 'guest' : 'auth'}/login`, data)
    .then(res => {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.session.token
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const logout = (payload, typeLogout) => {
  return axios.post(`/${typeLogout}/logout`, payload)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const resetPasswordMail = (data) => {
  return axios.post('/auth/reset/password/email', data)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const resetPassword = (data) => {
  return axios.post('/auth/reset/password', data)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const checkResetPwdExpired = (data) => {
  return axios.post('/auth/reset-password/link-checking', data)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const authVerify = (data) => {
  return axios.put('/auth/verify', data)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getEmailChecking = (data) => {
  return axios.post('/auth/email-checking', data)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const postResendEmail = (data) => {
  return axios.post('/auth/resend/email', data)
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const guestPersonalData = payload => axios.put('guest/personal-data', payload)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getAreaList = () => {
  return axios.get('/auth/area')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getIndustryList = () => {
  return axios.get('/auth/industry')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getCompTradeRole = () => {
  return axios.get('/auth/trade-roles')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}

export const getDialCode = () => {
  return axios.get('/auth/country-phone-code')
    .then(res => res)
    .catch(err => {
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/auth.api.js